import BaseService from '@/services/BaseService';

class StatsService extends BaseService {
    getDashboardCards = () => this.get('/get-dashboard-cards');

    getUsersByLocation = () => this.get('/get-users-by-location');

    getGraphData = () => this.get('/get-graph-data');

    getProducts = (data) => this.post(`/get-product-stats?page=${data.page}&per_page=${data.per_page}`, data || {});

    getReportCards = (data) => this.post('/get-report-cards', data || {});

    getCustomerListOptions = () => this.get('/get-customer-list-options');
}

export default new StatsService();
